var map = {
	"./de-DE.json": [
		812,
		[
			812
		]
	],
	"./en-GB.json": [
		3790,
		[
			790
		]
	],
	"./es-ES.json": [
		3150,
		[
			150
		]
	],
	"./fr-FR.json": [
		634,
		[
			634
		]
	],
	"./it-IT.json": [
		7812,
		[
			431
		]
	],
	"./nl-NL.json": [
		8226,
		[
			226
		]
	],
	"./pl-PL.json": [
		7214,
		[
			214
		]
	],
	"./pt-PT.json": [
		3614,
		[
			614
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4782;
module.exports = webpackAsyncContext;